import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { memo, useState, useEffect, useCallback } from 'react';
import { buildID } from '../../../data/utilities/Concatenation';
import { useAssignment } from '../../assignment/AssignmentsContext';
import { useChartData } from '../../context/ChartContext';
import { useHighlightData, useHighlight } from '../../highlight';
import { get2DXScale, get2DYScale } from '../utilities/scale';
import SignalCrosshair from './SignalCrosshair';
function Signal({ signal, isVisible }) {
    const { margin, width, height, xDomain, yDomain } = useChartData();
    const scaleX = get2DXScale({ margin, width, xDomain });
    const scaleY = get2DYScale({ margin, height, yDomain });
    const buildIDs = useCallback((id) => {
        return [id].concat(buildID(id, 'X'), buildID(id, 'Y'));
    }, []);
    const assignment = useAssignment(signal.id);
    const highlight = useHighlight(buildIDs(assignment.id));
    const highlightData = useHighlightData();
    const [isHighlighted, setIsHighlighted] = useState(false);
    useEffect(() => {
        if (highlightData.highlight.highlighted.some((_highlighted) => buildIDs(signal.id).includes(_highlighted)) ||
            assignment.isActive) {
            setIsHighlighted(true);
        }
        else {
            setIsHighlighted(false);
        }
    }, [
        assignment.isActive,
        buildIDs,
        highlightData.highlight.highlighted,
        signal.id,
    ]);
    if (!signal)
        return null;
    return (_jsxs("g", { className: "zone-signal", children: [isVisible.signals && (_jsxs("g", { children: [_jsx(SignalCrosshair, { signal: signal }), _jsx("circle", { onMouseEnter: () => {
                            assignment.show();
                            highlight.show();
                        }, onMouseLeave: () => {
                            assignment.hide();
                            highlight.hide();
                        }, cx: scaleX(signal.x.delta || 0), cy: scaleY(signal.y.delta || 0), r: isHighlighted ? 6 : 4, fill: isHighlighted ? 'green' : 'darkgreen' }, signal.id)] })), _jsx("g", { className: "zone-signal-peak", style: { pointerEvents: 'none' }, children: isVisible.peaks &&
                    signal.peaks &&
                    signal.peaks.map((peak, i) => (_jsx("circle", { cx: scaleX(peak.x), cy: scaleY(peak.y), r: 2, fill: "black" }, `${signal.id + i}`))) })] }));
}
export default memo(Signal);
